<template>
  <div class="container">
    <div class="breadcrumbs flex flex-wrap py-4">
      <nuxt-link :to="localePath('architecture')">{{
        $t('architecture')
      }}</nuxt-link>
      <ProjectNavigation />
    </div>

    <div class="flex flex-wrap flex-col-reverse md:flex-row">
      <div class="quote w-full md:w-1/3 flex flex-col project-sidebar">
        <div class="sticky top-0 pb-4">
          <p class="project-name text-4xl mb-0">{{ project.name }}</p>
          <p class="text-cyan text-2xl mt-0">
            {{ project.category_name[$i18n.locale] }}
          </p>
          <ul>
            <li>
              <div class="flex">
                <span class="font-semibold">{{ $t('Project team') }}</span>
                <v-icon
                  @click.native="showTeam = !showTeam"
                  :class="{ '-rotate-180': showTeam }"
                  name="chevron-down"
                  class="transform transition duration-300 font-semibold cursor-pointer inline-flex justify-center items-center h-6 w-6 p-1 leading-none"
                >
                </v-icon>
              </div>
              <div v-if="showTeam" v-html="project.stats['project_team']"></div>
            </li>
            <li v-for="(value, name) of project.stats" :key="name">
              <div v-if="value !== '//' && name != 'project_team'">
                <span class="font-semibold">{{ $t(name) }}</span>
                :
                {{ name !== 'status' ? value : $t(value) }}
              </div>
            </li>
          </ul>
          <div class="w-full pt-4">
            <div
              v-html="project.description[$i18n.locale]"
              class="project-description"
            ></div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-2/3 mt-0 md:mt-0">
        <!-- <div v-swiper:mySwiper="swiperOption" class="swiper"> -->
        <div class="gallery-choose">
          <button
            :class="[{ active: choice == 'gallery' }, 'uppercase', 'mr-3']"
            @click="choice = 'gallery'"
          >
            {{ $t('gallery') }}
          </button>
          <button
            :class="[{ active: choice == 'plan' }, 'uppercase']"
            @click="choice = 'plan'"
          >
            {{ $t('schemas') }}
          </button>
        </div>
        <div class="gallery relative">
          <no-ssr>
            <div v-swiper:mySwiper="swiperOption" class="swiper">
              <div class="swiper-wrapper">
                <div
                  v-if="project.has_gif && choice === 'plan'"
                  class="swiper-slide"
                >
                  <img
                    :src="'/img/' + project.slug + '/slower.gif'"
                    loading="lazy"
                  />
                </div>
                <div
                  v-for="index in project[`${choice}_count`]"
                  :key="index"
                  class="swiper-slide"
                >
                  <img
                    :src="
                      '/img/' +
                        project.slug +
                        '/' +
                        choice +
                        ' (' +
                        index +
                        ').jpg'
                    "
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div class="swiper-pagination-index z-10 mt-2"></div>
          </no-ssr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projects from '~/static/json/projects.json'
import ProjectNavigation from '~/components/ProjectNavigation'

export default {
  components: {
    ProjectNavigation
  },
  data() {
    return {
      showTeam: false,
      choice: 'gallery',
      swiperOption: {
        pagination: {
          el: '.swiper-pagination-index',
          clickable: true
        },
        autoplay: {
          delay: 7000,
          disableOnInteraction: false
        }
        // some swiper options...
      }
    }
  },
  asyncData({ params }) {
    const slug = params.slug
    const project = projects.find((project) => {
      return project.slug === slug
    })
    // delete project.stats.project_team
    delete project.stats.authors

    return { project }
  },
  created() {
    if (this.project.has_gif) {
      this.swiperOption.autoplay.delay = 10000
    }
  }
}
</script>
<style lang="postcss">
.slider-1 .swiper {
  height: 200px;
}

.swiper {
  img {
    max-height: 600px;
    width: 100%;
    object-fit: contain;
    /* object-position: 0 50%; */
  }
}

.swiper-pagination-bullet {
  height: 14px !important;
  width: 14px !important;
  /* border-radius: 0 !important; */
  /* outline: 5px solid yellow; */
}

.swiper-pagination-bullet-active {
  background: #11b3f0;
}

.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -15px;
  width: auto;
  padding: 5px;
}

.swiper-pagination {
  background: rgba(0, 0, 0, 0.2);
  text-align: left;
  padding-left: 15px;
}

.swiper-pagination-index {
  width: 100%;
  display: flex;
  justify-content: center;
}

.slider-2 {
  margin-top: 10px;
  .swiper {
    height: 200px;
  }

  .swiper-pagination-bullet {
    height: 14px;
    width: 14px;
    /* border-radius: 100%; */
    font-size: 24px;
    margin-right: 10px;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0;
    width: auto;
    padding: 5px;
  }
  img {
    object-fit: contain;
  }
}

.navigation {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
}

@screen sm {
  .slider-1 .swiper {
    height: 500px;
  }

  .slider-2 {
    margin-top: 0;
  }

  .slider-2 .swiper {
    height: 400px;
  }
}
.gallery {
  display: flex;
  flex-wrap: wrap;
}

.project-sidebar {
  @screen md {
    position: sticky;
    top: 50px;
  }
}
.gallery-choose {
  @apply text-gray-500;
}
.gallery-choose a:focus,
.gallery-choose button:focus {
  outline: none;
}
.gallery-choose .active {
  @apply text-black;
}
</style>
<style scoped></style>
